import { AbstractControl } from '@angular/forms';

/**
 * Accessible submit for forms that keep their save button enabled (WCAG 3.3.1).
 *
 * A disabled save button gives no reason why it can't be used. Instead, when the form is
 * invalid this shows every field's error and moves focus to the first invalid field, whose
 * mat-error is linked to it so screen readers announce it.
 *
 * @returns true when the form is valid and can be submitted
 */
export function revealFormErrors(form: AbstractControl, scope: ParentNode = document): boolean {
  if (form.valid) {
    return true;
  }

  form.markAllAsTouched();

  // Wait for change detection to apply the invalid state to the fields
  setTimeout(() => {
    const firstInvalid = scope.querySelector<HTMLElement>(
      '.mat-form-field-invalid input, .mat-form-field-invalid textarea, .mat-form-field-invalid mat-select'
    );
    firstInvalid?.focus();
  });

  return false;
}
